import {
  ItemIds,
  LayoutColumnsDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  MESSAGE,
  TEXT,
  TEXT_MESSAGES,
  ADD_NEW_ITEM
} from '../items';
import { ItemDefinition } from '../items/Item';
import { Translator } from '../Translator';
import { translate } from './translate';
import { useEditorStore } from '~/shell/Store';

export const SocialMedia1: Translator = sequence => {
  const root = translate(sequence, () => null);
  const messages: ItemDefinition<ItemIds>[] = [];
  const rightSide: ItemDefinition<ItemIds>[] = [];

  let isContentEditable = false;
  try {
    const { contentEditable } = useEditorStore.getState();
    isContentEditable = !!contentEditable;
  } catch (e) {
    // ignore if store not available
  }

  sequence.items?.forEach(item => {
    if (item.__typename == 'List') {
      const elementItems = item?.items ? item.items : [];
      elementItems?.forEach(element => {
        const valuesData = element.title ? { sender: element.title } : {};

        messages.push({
          type: MESSAGE,
          id: element.id,
          start: 0,
          values: valuesData,
          items: [
            {
              type: TEXT,
              id: `${element.id}_body`,
              items: [],
              values: {
                value: element.body
              }
            }
          ]
        });
      });

      if (isContentEditable && item?.items && item?.items?.length > 0) {
        messages.push({
          type: ADD_NEW_ITEM,
          id: `_add_new_item`,
          items: [],
          values: {
            type: 'text'
          }
        });
      }
    }

    if (item.__typename === 'Text') {
      rightSide.push({
        type: TEXT,
        id: `${item.id}_subtitle`,
        items: [],
        values: {
          value: item.subtitle || 'QUIZ',
          variant: 'sub_heading',
          icon: item.icon
        }
      });

      rightSide.push({
        type: TEXT,
        id: `${item.id}_title`,
        items: [],
        values: {
          value: item.title || '',
          variant: 'heading2'
        }
      });

      rightSide.push({
        type: TEXT,
        id: `${item.id}_body`,
        items: [],
        values: {
          value: item.body || ''
        }
      });
    }
  });

  if (rightSide && rightSide.length) {
    root.items.push({
      id: `${sequence.id}-columns`,
      type: LAYOUT_COLUMNS,
      items: [
        {
          type: TEXT_MESSAGES,
          id: '1',
          items: messages,
          values: {
            value: '',
            variant: 'llama'
          }
        },
        {
          id: 'list',
          type: LAYOUT_LIST,
          values: {
            align: 'left',
            height: { _: 'auto', lg: '100%' },
            padded: true
          },
          items: rightSide
        } as LayoutListDefinition
      ]
    } as LayoutColumnsDefinition);
  } else {
    root.items.push({
      id: `${sequence.id}-columns`,
      type: LAYOUT_COLUMNS,
      items: [
        {
          type: TEXT_MESSAGES,
          id: '1',
          items: messages,
          values: {
            value: '',
            variant: 'llama'
          }
        }
      ]
    } as LayoutColumnsDefinition);
  }

  return root;
};
